<template>
  <div class="main-bar">
    <div class="grid">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="(item, index) in list"
        :key="item.id"
        class="grid__item"
      >
        <div class="card" :class="`card-${index + 1}`">
          <div class="card__img">
            <div class="card__category-img">{{ item.sub_category.name }}</div>
            <ImageContainer
              style="overflow: visible; boreder-radius: 0px"
              class="img"
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
            />
          </div>
          <div class="card__descr">
            <div class="card__category-descr">
              {{ item.sub_category.name }}
            </div>
            <div class="card__title limited-text">{{ item.title }}</div>
            <div class="data-news">
              <span class="day">{{ handleDate(item.pub_date) }},</span>
              <span class="time">{{ handleTime(item.pub_date) }}</span>
            </div>
          </div>
          <div class="card__brief">
            <div class="limited-text" style="--snup:5">
              {{ item.brief }}
            </div>
            <div class="data-news-brief">
              <span class="day">{{ handleDate(item.pub_date) }},</span>
              <span class="time">{{ handleTime(item.pub_date) }}</span>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";

export default {
  components: { ImageContainer },

  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.main-bar {
  width: 100%;
  padding-top: calc(max(180px, 10vw));
}
.card {
  &__title{
    margin-top: 0.5rem;
  }
  &__brief {
    display: none;
  }
  &__img {
    overflow: hidden;
    :deep() .main-image img {
      border-radius: 0px;
      overflow: visible;
    }
  }
}
.grid {
  display: grid;
  // gap: 0 45px;
  width: 100%;
  grid-template-columns: 31.5% 47% 21.5%;
  // grid-template-rows: repeat(5, 168px) 200px;

  &__item:nth-child(1) {
    grid-template-columns: 1;
    grid-row: 1 / span 3;
  }
  &__item:nth-child(2) {
    grid-row: 1 / span 5;
    grid-template-columns: 1;
  }
  &__item:nth-child(3) {
    grid-row: 4 / span 3;
    grid-template-columns: 1;
  }

  &__item:nth-child(4),
  &__item:nth-child(5),
  &__item:nth-child(6) {
    grid-column: 3 / span 1;
    // grid-row: 1 / span 3;
  }
  .card-1,
  .card-3 {
    .card__img {
      height: 23vw;
      // .img {
      //   padding-bottom: 75%;
      // }
    }
    .card__category-img {
      display: none;
    }
    .card__descr {
      background: var(--dark-bg);
      width: 80%;
      margin-left: auto;
      transform: translateY(-90px);
      position: relative;
      padding: 15px;
      .card__category-descr {
        margin-bottom: 5px;
      }
    }
    .data-news {
      position: absolute;
      right: 15px;
      top: 10px;
    }
  }
  .card-2 {
    padding: 0 45px;
    .data-news-brief {
      display: block;
    }
    .card__brief {
      display: block;
      transform: translateY(-10px);
      margin-left: 30px;
    }
    .card__img {
      // height: 532px;
      .img {
        padding-bottom: 75%;
      }
    }
    .card__category-img {
      display: none;
    }
    .card__descr {
      background: var(--dark-bg);
      width: 80%;
      margin-left: auto;
      transform: translateY(-75px);
      position: relative;
      padding: 15px;
    }
    .card__category-descr {
      margin-bottom: 5px;
    }
    .data-news {
      display: none;
      @media screen and (max-width: 992px) {
        display: block;
      }
    }
  }

  .card-4,
  .card-5,
  .card-6,
  .card-7,
  .card-8 {
    .card__category-img {
      display: none;
    }
    padding: 1em 0;
    height: 100%;
    border-bottom: 1px solid #0e2a45;
    transform: translateY(-2rem);
  }
  .card-8 {
    border-bottom: none;
  }
  .card-9 {
    padding: 0 45px;

    display: flex;
    gap: 1rem;
    .card__category-descr {
      margin-bottom: 7px;
    }
    .card__category-img {
      display: none;
    }
    .card__img {
      // height: 156px;
      height: 8vw;
      flex: 1 0 29%;
    }
    .card__descr {
      display: flex;
      flex-direction: column;
      .data-news {
        margin-top: auto;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .card-9 {
    transform: translateY(-40%);
    .card__img {
      // height: 156px;
      height: 100%;
    }
  }
}
@media screen and (max-width: 1366px) {
  .card__brief {
    transform: translateY(-60px) !important;
  }
}
@media screen and (max-width: 992px) {
  .card__brief {
    transform: translateY(0px) !important;
  }
  .card{
    &__title{
      margin-top: 0;
    }
  }
  .main-bar {
    padding-top: 1rem;
    padding-bottom: 0rem;
  }
  .grid {
    grid-template-columns: 50% 50%;
    grid-template-rows: auto;
    gap: 10px 0;
    &__item {
      grid-column: 1 / span 2;
      grid-row: auto;
      padding: 15px 0;
    }
    &__item:nth-child(1) {
      grid-column: 1 / span 2;
      grid-row: 1 / span 1;
    }
    &__item:nth-child(2) {
      background: var(--dark-blog-bg);

      grid-column: 1 / span 2;
      grid-row: 2 / span 1;
    }
    &__item:nth-child(3) {
      grid-column: 1 / span 1;
      grid-row: 3 / span 1;
    }
    &__item:nth-child(4) {
      grid-column: 2 / span 1;
      grid-row: 3 / span 1;
    }
    &__item:nth-child(5) {
      grid-column: 1 / span 1;
      grid-row: 4 / span 2;
      padding: 0;
    }
    &__item:nth-child(6) {
      height: 100%;
      padding: 0;

      grid-column: 2 / span 1;
      grid-row: 4 / span 1;
    }
    &__item:nth-child(7) {
      height: 100%;
      padding: 0;

      grid-column: 2 / span 1;
      grid-row: 5 / span 1;
    }
    &__item:nth-child(9) {
      background: var(--dark-blog-bg);
    }
    .card {
      border: none;
      transform: translate(0);
    }
    .card-1,
    .card-8 {
      padding: 0;
      display: flex;
      gap: 1rem;
      max-width: 70%;
      margin: 0 auto;
      .card__descr {
        position: relative;
        width: 100%;
        margin: 0;
        padding: 0;
        transform: translate(0);
        background: transparent;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .card__category-descr {
        display: none;
      }
      .card__category-img {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        background-color: var(--dark-bg);
      }
      .data-news {
        position: relative;
        left: 0;
        top: 0;
      }
      .card__img {
        flex: 0 0 36%;
        height: auto;
        position: relative;
        .img {
          padding-bottom: 75%;
        }
      }
    }
    .card-2,
    .card-9 {
      padding: 0;
      display: flex;
      flex-direction: row-reverse;
      gap: 1rem;
      max-width: 70%;
      margin: 0 auto;
      .card__descr {
        position: relative;
        width: 100%;
        margin: 0;
        padding: 0;
        transform: translate(0);
        background: transparent;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: right;
      }
      .card__category-descr {
        display: none;
      }
      .card__category-img {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        background-color: var(--dark-bg);
      }
      .card__brief {
        display: none;
      }
      .data-news {
        position: relative;
        left: 0;
        top: 0;
      }
      .card__img {
        position: relative;
        flex: 0 0 36%;
        height: auto;
        .img {
          padding-bottom: 75%;
        }
      }
    }
    .card-3,
    .card-4 {
      padding: 0;
      gap: 1rem;
      max-width: 70%;
      margin: 0 auto;

      .card__descr {
        position: relative;
        width: 100%;
        margin: 0;
        padding: 0;
        transform: translate(0);
        background: transparent;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
      }
      .card__category-descr {
        display: block;
      }

      .card__brief {
        display: none;
      }
      .data-news {
        position: relative;
        left: 0;
        top: 0;
      }
      .card__img {
        display: none;
        position: relative;
        flex: 0 0 36%;
        height: auto;
        .img {
          padding-bottom: 75%;
        }
      }
    }
    .card-5 {
      padding: 0 0rem 0 1rem;
      .card__img {
        // height: 100px;
        .img {
          padding-bottom: 76%;
        }
      }
      .card__descr {
        margin-top: 0.4rem;
        text-align: center;
      }
    }
    .card-6,
    .card-7 {
      height: 100%;
      background: var(--dark-blog-bg);
      padding: 0 1.2rem;
      margin-left: 2rem;
      .card__img {
        display: none;
      }
      .card__descr {
        height: 100%;
        text-align: right;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
    .card-7 {
      transform: translateY(-15px);
      .card__descr {
        justify-content: flex-start;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .main-bar {
    width: 85%;
    margin: 0 auto;
  }
  .grid {
    gap: 27px 0;
    &__item {
      background: transparent !important;
      padding: 0;
    }
    &__item:nth-child(1),
    &__item:nth-child(2),
    &__item:nth-child(3),
    &__item:nth-child(4) {
      grid-column: span 1;
    }
    &__item:nth-child(2) {
      grid-row: 1 / span 1;
      background: transparent;
    }
    &__item:nth-child(3) {
      grid-row: 2 / span 1;
      background: transparent;
    }
    &__item:nth-child(4) {
      grid-row: 2 / span 1;
      background: transparent;
    }
    &__item:nth-child(5) {
      grid-row: 3 / span 1;
      grid-column: span 2;
      background: transparent;
    }
    &__item:nth-child(6),
    &__item:nth-child(7),
    &__item:nth-child(8),
    &__item:nth-child(9) {
      grid-row: auto;
      grid-column: span 1;
    }
  }
  .card {
    padding: 0 !important;
    background: transparent !important;
    transform: translate(0) !important;
    &__title {
      --snup: 4;
      
    }
  }
  .card-1,
  .card-3,
  .card-6,
  .card-8 {
    margin: 0 !important;
    text-align: left;
    .card__title {
      text-align: left;
    }
    .data-news {
      text-align: left;
    }
    .card__category-descr {
      display: block !important;
      text-align: left;
    }
    .card__img {
      display: none;
    }
  }
  .card-2,
  .card-4,
  .card-7,
  .card-9 {
    margin: 0 10px;
    text-align: left;
    .card__title {
      text-align: left;
    }
    .data-news {
      text-align: left;
    }
    .card__category-descr {
      display: block !important;
      text-align: left;
    }
    .card__img {
      display: none;
    }
  }
  .card-5 {
    position: relative;
    .card__descr {
      width: 100%;
      position: absolute;
      bottom: 0;
      z-index: 2;
    }
    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 74px;
      background: linear-gradient(180deg, rgba(21, 35, 49, 0) 0%, #152331 100%);
      z-index: 1;
    }
  }
}
</style>
